module.exports = __webpack_public_path__ + "static/media/Results-5.c38c6571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proof/Results-5.jpg
// module id = 368
// module chunks = 0